<template>
    <div class="col-md-6">
        <div>
            <div class="selected" v-if="isActive">
                <i class="fa fa-check-circle-o"></i><span>Active</span>
            </div>
            <ul class="bold name">
                <li v-if="address.corporation_name">{{address.corporation_name}}</li>
                <li v-if="address.last_name">{{address.first_name}} {{address.last_name}}</li>
            </ul>
            <ul>
                <li>{{address.street_line1}}</li>
                <li v-if="address.street_line2">{{address.street_line2}}</li>
                <li>{{address.zipcode}} {{address.city}}</li>
                <li v-if="address.decoded_state">{{address.decoded_state}}</li>
                <li v-if="address.decoded_country">{{address.decoded_country}}</li>
                <li v-if="startDate.length"><span class="label label-success">Date de début: {{startDate}}</span></li>
                <li v-if="endDate.length" class="m-t-10">
                    <span class="label label-danger">Date de fin: {{endDate}}</span>
                </li>
                </address>
                <!-- <li>Jour de réexpedition : </li> -->
            </ul>
        </div>
        <br>
        <div class="button">
            <button class="btn btn-sm" @click="$emit('edit', address.id)" v-if="shouldEdit">Modifier</button>
            <button class="btn btn-sm btn-danger" @click="$emit('delete', address.id)" v-if="shouldDelete">Suprimmer</button>
            <button
                    title="Ouvre un nouvel onglet contenant les étiquettes prètes à être imprimer."
                    @click="downloadStamps(address)"
                    class="btn btn-sm btn-success"
            >
                <i class="pg-printer"></i> Etiquettes
            </button>

        </div>
    </div>
</template>

<style lang="scss" scoped>
    div {
        position: relative;
        .selected {
            position: absolute;
            right: 0;
            top: 10px;
            color: #cb4563;
            i {
                font-size: 1.2rem;
            }
            span {
                position: relative;
                bottom: 2px;
                font-weight: bold;
            }
        }
    }

    ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        li {
            line-height: 1.2rem;
        }
    }

    .name {
        font-size: 0.9rem;
    }

    .button {
        // position: absolute;
        // right: 0;
        // bottom: -10px;
    }
</style>

<script type="text/babel">
  import {mapState, mapActions} from "vuex"

    export default {

        props: {
            address: Object,
            shouldDelete: {
                type: Boolean,
                default: false
            },
            shouldEdit: {
                type: Boolean,
                default: true
            },
            isActive: {
                type: Boolean,
                default: false
            },
            contractId: {
                type: Number,
                default: -1,
            },
            requiredData: {
                type: Object,
                default: null,
            },
            customer: {
                type: Object,
                default: null,
            }
        },

        computed: {
            ...mapState("customer", ["contracts"]),

            currentContract(){
              return _.find(this.contracts, contract => contract.id == this.$route.params.contractId)
            },



            startDate () {
                const start_date = this.address.mail_forward_start_date
                return start_date ? moment(this.address.mail_forward_start_date).format('LL') : ""
            },

            endDate () {
                const end_date = this.address.mail_forward_end_date
                return end_date ? moment(this.address.mail_forward_end_date).format('LL') : ""
            },
        },

        methods: {

            toHtml(address) {
                var text = "\n\t\t\t<div class=\"etiquette\">"

                !_.isNil(this.address.corporation_name) && (text += "\n\t\t\t\t" + this.address.corporation_name + "<br/>")
                !_.isNil(this.address.last_name) && (text += "\n\t\t\t\t" + (_.isNil(this.address.first_name)? "" : this.address.first_name) + " " + this.address.last_name + "<br/>")
                text += "\n\t\t\t\t" + this.address.street_line1 + "<br/>"
                if (this.address.street_line2) {
                    text += "\n\t\t\t\t" + this.address.street_line2 + "<br/>"
                }
                text += "\n\t\t\t\t" + this.address.zipcode + " " + this.address.city + "<br/>"
                text += "\n\t\t\t\t" + this.address.decoded_country + "<br/>"
                // Replace and set the client number here when we will get the datas
                if ((this.customer && this.customer.erp_id) || this.currentContract.order.erp_id != null || this.address.mail_forward_end_date) {
                    text += "\n\t\t\t\t<div class=\"infoclient\">"
                    if (this.customer && this.customer.erp_id) {
                        text += this.customer.erp_id
                    }
                    if (this.currentContract.order.erp_id) {
                        text += " " + this.currentContract.order.erp_id
                    }
                    if (this.address.mail_forward_end_date) {
                        text += " - V: " + moment(this.address.mail_forward_end_date).format('L')
                    }
                    text += "</div>"
                }
                text += "\n\t\t\t</div>"
                return text
            },

            downloadStamps(address) {
                var text = "<html lang=\"fr\">\n\t<head>\n\t\t<meta charset=\"utf-8\">\n\t\t<title>Etiquettes " + this.address.corporation_name + "</title>"
                text += "\n\t<style type=\"text/css\">"
                text += "\n\t\t* { margin: none; padding: 0;}body { font-family: Arial; }"
                text += "\n\t\t .tabetiquette { width: 794px; height: 1122px; box-sizing: border-box; }"
                text += "\n\t\t .etiquette { color: #555; float: left; width: 50%; height: 12.5%; padding: 15px 30px 0 30px; box-sizing: border-box; font-size: 13px; }"
                text += "\n\t\t .etiquette .addresse {height: 95px;}"
                text += "\n\t\t .etiquette .infoclient {color: #a5a5a5;font-size:11px;text-align: right;} </style>"
                text += "\n\t</head>\n\t<body>\n\t\t<div class=\"tabetiquette\">"
                var filename = "etiquettes-" + this.address.corporation_name
                for (var i = 0; i < 16; i++) {
                    text += this.toHtml(address);
                }
                text += "</body></html>"
                var x = window.open()
                if (x.document) {
                    var isChrome = Boolean(window.chrome)

                    x.document.open()
                    x.focus()
                    x.document.write(text)

                    if (isChrome) {
                        setTimeout(function () { // wait until all resources loaded 
                            x.print();
                            x.document.close()
                            x.close();
                        }, 200);
                    }
                    else {
                        x.print();
                        x.document.close()
                        x.close();
                    }
                }
            }
        },
    }

</script>



// WEBPACK FOOTER //
// client/components/Customer/ContractManagementContent/ForwardingAddresses/ForwardingAddress.vue